import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp, FaFacebook, FaInstagram, FaLocationArrow } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#1E293B] text-white pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] bg-clip-text text-transparent mb-4">
            Dr. Sainulabid's IQRA Multispeciality Dental Clinic
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            Providing advanced multispeciality dental care with experienced doctors, modern technology and compassionate patient care in Athavanad, Malappuram.
          </p>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-400">Quick Links</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><a href="#home" className="hover:text-teal-400 transition">Home</a></li>
            <li><a href="#about" className="hover:text-teal-400 transition">About</a></li>
            <li><a href="#services" className="hover:text-teal-400 transition">Services</a></li>
            <li><a href="#doctor" className="hover:text-teal-400 transition">Doctors</a></li>
            <li><a href="#faq" className="hover:text-teal-400 transition">FAQ</a></li>
            <li><a href="#contact" className="hover:text-teal-400 transition">Contact</a></li>
          </ul>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-400">Contact Info</h3>
          <p className="text-gray-400 text-sm flex items-start gap-2 mb-2">
            <FaMapMarkerAlt className="text-teal-400 mt-0.5 flex-shrink-0" />
            Near PMSA Yatheemkhana, Kattilangadi, Athavanad, Kerala - 676301
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-2">
            <FaPhoneAlt className="text-teal-400 flex-shrink-0" />
            +91 85903 00370
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-2 mt-2">
            <FaWhatsapp className="text-green-400 flex-shrink-0" />
            +91 85909 99451
          </p>
          <a
            href="https://maps.app.goo.gl/V4443oiUAViE139R6"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-sm text-teal-400 hover:text-teal-300 transition"
          >
            <FaLocationArrow className="text-sm" />
            Get Directions
          </a>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-400">Connect With Us</h3>
          <div className="flex gap-4 mb-6">
            <a href="https://wa.me/918590999451" target="_blank" rel="noopener noreferrer" className="bg-green-500 p-3 rounded-full hover:scale-110 transition">
              <FaWhatsapp />
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 p-3 rounded-full hover:scale-110 transition">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="bg-pink-600 p-3 rounded-full hover:scale-110 transition">
              <FaInstagram />
            </a>
          </div>
          <a href="tel:+918590300370" className="block text-center bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] px-4 py-2 rounded-lg text-sm hover:shadow-lg transition">
            Call Now
          </a>
        </div>
      </div>
      
      <div className="text-center text-gray-500 text-sm mt-10 pt-6 border-t border-gray-800">
        <p>
          © {new Date().getFullYear()} Dr. Sainulabid's IQRA Multispeciality Dental Clinic.
          All rights reserved.
        </p>
        <p className="mt-2 text-xs text-gray-400">
          Website Designed &amp; Developed by{" "}
          <a
            href="https://rashnex.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-teal-400 hover:text-teal-300 transition-colors"
          >
            RASHNEX Digital Solutions
          </a>
        </p>
        <p className="mt-1 text-[10px] text-gray-500">
          Web Design • Development • SEO
        </p>
      </div>
    </footer>
  );
}